import{diContainer as r}from"./container.js";var t=function(t){return r.get(t)},n=function(t,n){return r.set(t,n)};export{t as inject,n as rebind};
